var _defs, _path, _path2, _path3, _g, _path4, _ellipse, _ellipse2, _ellipse3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayrollOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05",
    x1: 75.58,
    y1: 27.98,
    x2: 117.84,
    y2: 27.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05",
    "data-name": "C_BG_shellbar",
    x1: 75.58,
    y1: 40.98,
    x2: 117.84,
    y2: 40.98,
    gradientTransform: "translate(0 -13)",
    xlinkHref: "#SVGID_0_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05",
    "data-name": "C_BG_shellbar",
    x1: 85.14,
    y1: 69.98,
    x2: 109.72,
    y2: 69.98,
    xlinkHref: "#SVGID_0_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M84.83 117.93h64.21M84.83 111.35h64.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M144.73 132.66s-.68-3.9-3.9-3.9c-3.23 0-4.09 3.9-4.09 3.9l8.38 6.34M137.13 139.01s.68 3.9 3.9 3.9c3.23 0 4.09-3.9 4.09-3.9M140.92 125.44l.01 3.32M140.94 142.91v3.32M130.91 132.66s-.68-3.9-3.9-3.9c-3.23 0-4.09 3.9-4.09 3.9l8.38 6.34M123.31 139.01s.68 3.9 3.9 3.9c3.23 0 4.09-3.9 4.09-3.9M127.1 125.44l.01 3.32M127.12 142.91v3.32M116.86 132.66s-.68-3.9-3.9-3.9c-3.23 0-4.09 3.9-4.09 3.9l8.38 6.34M109.26 139.01s.68 3.9 3.9 3.9c3.23 0 4.09-3.9 4.09-3.9M113.05 125.44v3.32M113.07 142.91v3.32M103.04 132.66s-.68-3.9-3.9-3.9c-3.23 0-4.09 3.9-4.09 3.9l8.38 6.34M95.44 139.01s.68 3.9 3.9 3.9c3.23 0 4.09-3.9 4.09-3.9M99.23 125.44v3.32M99.24 142.91l.01 3.32M106.42 146.46v.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M83.46 130.85H62.14c-2.31 0-4.19-2.08-4.19-4.64V30.55c0-2.56 1.88-4.64 4.19-4.64h15.61M116.39 25.91h14.89c2.31 0 4.19 2.08 4.19 4.64v79.91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05)",
    d: "M112.68 33.61l4.06-11.27H76.68l4.06 11.27h31.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05)",
    d: "M112.68 33.61l4.06-11.27H76.68l4.06 11.27h31.94z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M107.44 69.52a8.18 8.18 0 017.57-5.08c3.86 0 7.09 2.68 7.95 6.28M70.46 70.84c.81-3.66 4.07-6.4 7.98-6.4 4.23 0 7.7 3.21 8.13 7.33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 115.21,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 97.61,
    cy: 57.41,
    rx: 6.71,
    ry: 6.6
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "MI_4L_main",
    cx: 78.45,
    cy: 59.78,
    rx: 4.75,
    ry: 4.67
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M85.59 75.36c.57-6.04 5.66-10.76 11.84-10.76s11.22 4.68 11.83 10.67",
    stroke: "url(#SVGID_2_a8d437f536c134f68b608e5268d2d6e1b9a39ba08c81415648814fcf44c1bf05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M85.59 75.36c.57-6.04 5.66-10.76 11.84-10.76s11.22 4.68 11.83 10.67"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollOverview);
export default __webpack_public_path__ + "static/media/payrollOverview.fbea8911c0d1c2d844a888d163ab0ea0.svg";
export { ForwardRef as ReactComponent };